import { TableColumnsType } from 'antd';
import { DataTypeReportICTServices } from 'store/ducks/Reportings/types';

export const columns: TableColumnsType<DataTypeReportICTServices> = [
  {
    title: 'Name of the financial entity',
    width: 100,
    dataIndex: 'entity_name',
    key: 'entity_name',
    fixed: 'left',
  },
  {
    title: 'ICT service description',
    width: 100,
    dataIndex: 'ict_service_description',
    key: 'ict_service_description',
  },
  {
    title: 'ICT Services Valid from',
    width: 100,
    dataIndex: 'start_date',
    key: 'start_date',
  },
  {
    title: 'ICT Services Valid to',
    width: 100,
    dataIndex: 'end_date',
    key: 'end_date',
  },
  {
    title: 'Notice period',
    width: 100,
    dataIndex: 'notice_period',
    key: 'notice_period',
  },
  {
    title: 'Rank',
    width: 100,
    dataIndex: 'rank',
    key: 'rank',
  },
  {
    title: 'Recipient identification code',
    width: 100,
    dataIndex: 'recipient_identification_code',
    key: 'recipient_identification_code',
  },
  {
    title: 'Recipient identification type',
    width: 100,
    dataIndex: 'recipient_identification_type',
    key: 'recipient_identification_type',
  },
  {
    title: 'Alternative exit',
    width: 100,
    dataIndex: 'alternatives_exit',
    key: 'alternatives_exit',
  },
  {
    title: 'Auswahl services discount',
    width: 100,
    dataIndex: 'auswahl_services_discount',
    key: 'auswahl_services_discount',
  },
  {
    title: 'Contractual arrangement',
    width: 100,
    dataIndex: 'contractual_arrangement',
    key: 'contractual_arrangement',
  },
  {
    title: 'Country',
    width: 100,
    dataIndex: 'country',
    key: 'country',
  },
  {
    title: 'Criticality assessment',
    width: 100,
    dataIndex: 'criticality_assessment',
    key: 'criticality_assessment',
  },
  {
    title: 'Exit plan exists',
    width: 100,
    dataIndex: 'exit_plan_exists',
    key: 'exit_plan_exists',
  },
  {
    title: 'Function name',
    width: 100,
    dataIndex: 'function_name',
    key: 'function_name',
  },
  {
    title: 'ICT service level',
    width: 100,
    dataIndex: 'ict_service_level',
    key: 'ict_service_level',
  },
  {
    title: 'ICT service type',
    width: 100,
    dataIndex: 'ict_service_type',
    key: 'ict_service_type',
  },
  {
    title: 'ICT services criticality',
    width: 100,
    dataIndex: 'ict_services_criticality',
    key: 'ict_services_criticality',
  },
  {
    title: 'Impact of discontinuing function',
    width: 100,
    dataIndex: 'impact_of_discontinuing_function',
    key: 'impact_of_discontinuing_function',
  },
  {
    title: 'Impact of discontinuing ICT services',
    width: 100,
    dataIndex: 'impact_of_discontinuing_ict_services',
    key: 'impact_of_discontinuing_ict_services',
  },
  {
    title: 'Level of reliance',
    width: 400,
    dataIndex: 'level_of_reliance',
    key: 'level_of_reliance',
  },
  {
    title: 'level of supporting ICT services',
    width: 100,
    dataIndex: 'level_of_supporting_ict_service',
    key: 'level_of_supporting_ict_service',
  },
  {
    title: 'Local regulator criticality',
    width: 100,
    dataIndex: 'local_regulator_criticality',
    key: 'local_regulator_criticality',
  },
  {
    title: 'possibility of reintegration',
    width: 100,
    dataIndex: 'possibility_of_reintegration',
    key: 'possibility_of_reintegration',
  },
  {
    title: 'Storage of data',
    width: 100,
    dataIndex: 'storage_of_data',
    key: 'storage_of_data',
  },
  {
    title: 'Substitutability of ICT provider',
    width: 100,
    dataIndex: 'substitutability_of_ict_provider',
    key: 'substitutability_of_ict_provider',
  },
  {
    title: 'Third party service provider name',
    width: 100,
    dataIndex: 'third_party_service_provider_name',
    key: 'third_party_service_provider_name',
  },
  {
    title: 'TPP code type',
    width: 100,
    dataIndex: 'tpp_code_type',
    key: 'tpp_code_type',
  },
  {
    title: 'Selected Date',
    width: 100,
    dataIndex: 'date',
    key: 'date',
  },
];
